import {Ajax} from '../utils/ajax';

export class ToastMessage {

  static get TIMEOUT() {
    return 5500;
  }

  constructor(root) {
    this.root = root;
    this.actionButton = this.root.querySelector('.action-button');
  }

  setActionCallback(callback) {
    this.actionButton.addEventListener('click', (e) => {
      callback(e);
      this.toggle(false);
    });
  }

  toggle(show) {
    if(show) {
      this.root.classList.add('show');

      setTimeout(() => {
        this.toggle(false);
      }, ToastMessage.TIMEOUT);
    } else {
      this.root.classList.remove('show');
      setTimeout(() => {
        this.root.remove();
      }, 500);
    }
  }

  /**
   * Displays a toast message on the screen.
   *
   * @static
   * @param {Object} options - Configuration options for the toast message.
   * @param {string} options.message - The message to be displayed in the toast.
   * @param {string} [options.icon=null] - The icon to be displayed in the toast.
   * @param {string} [options.action='Dismiss'] - The action to be performed when the toast is clicked.
   * @param {Function} [options.actionCallback] - The callback function to be executed when the action is performed. By default, it removes the toast message from the screen.
   * @returns {void}
   * @throws Will throw an error if `options` is not provided.
   * @throws Will throw an error if `options.message` is not provided.
   * @throws Will throw an error if `options.action` is provided but `options.actionCallback` is not.
   */
  static show(options) {
    if(!options) {
      return;
    }
    if(!options.message) {
      console.error('No message provided');
      return;
    }

    const message = options.message;
    const icon = options.icon || null;
    const action = options.action || 'Dismiss';
    const actionCallback = options.actionCallback || (() => {
      const root = document.querySelector('#system-toast-message');
      if(root) {
        root.classList.remove('show');
        setTimeout(() => {
          root.remove();
        }, 500);
      }
    });

    if(!!action && !actionCallback) {
      console.error('Action provided without actionCallback');
      return;
    }

    Ajax.getToastMessageMarkup(message, icon, action, (err, response) => {
      if(err) {
        console.error(err);
        return;
      }

      if(!response) {
        console.error('No response from server');
        return;
      }

      if(!response.success) {
        console.error('Server error');
        return;
      }

      const data = response.data;
      const html = data.html;

      const existingToast = document.querySelector('#system-toast-message');
      if(existingToast) {
        existingToast.remove();
      }
      document.body.insertAdjacentHTML('beforeend', html);

      const toastRoot = document.querySelector('#system-toast-message');
      const toastMessage = new ToastMessage(toastRoot);

      if(actionCallback) {
        toastMessage.setActionCallback(actionCallback);
      }

      setTimeout(() => {
        toastMessage.toggle(true);
      }, 100);
    });
  }

}
